import React from "react"
import { Button } from "react-bootstrap"

import POSSaleContext from "../../../context"

export default props => {
    function gotToPayment() {
        window.location.href = "/pos/payment"
    }
    return <POSSaleContext.Consumer>
        {
            sale => <div className={props.className}>
                <Button
                    disabled={!sale.items.length}
                    onClick={gotToPayment}
                    className="w-100 dim py-2"
                    variant="success">
                    Avançar
                </Button>
            </div>
        }
    </POSSaleContext.Consumer>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/FooterActionsPOS/GoToPayments/index.jsx